import React, { useState, useEffect,useRef  } from 'react';
import {
    Input, Form, TextArea, Tabs, Radio, PlusOutlined, Select, DatePicker, Divider, EditFilled, Avatar, useDispatch,
    useSelector, Button, format, message, Empty,Spin, TeamOutlined,Tooltip, Drawer
} from '../AntComponent';
import EffortSummary from './project-tabs/EffortSummary';
import ProjectDetailScreen from './project-tabs/ProjectDetailScreen';
import ProjectPlan from './project-tabs/ProjectPlan';
import GanttChart from './project-tabs/GanttChart';
import { getDepartmentDetails, getProjDetail, getProjectManager, getProjectMemberList, saveProjectMember,saveProject ,deleteProjectMember} from '../../store/actions/project-management/ProjectAction';
import { getProjectRole, getProjectType,getProjectManagerList } from '../../store/actions/project-management/ProjectSettingAction';
import AddProject from './modal/AddProject';
import moment from 'moment/moment';
import nonEditIcon from "../../assets/icons/edit.png"
import editIcon from "../../assets/icons/pencil.png"
import FinanceByRole from './project-tabs/FinanceByRole';
import { setMinutes } from 'date-fns';
const dayjs = require('dayjs');

export default function ProjectDetail(props) {
    const [form] = Form.useForm();
    const [form1] = Form.useForm();
    const formRefs = useRef()
    const dispatch = useDispatch(); 
    const { roleList,typeList,projMngList } = useSelector(state => state.projectSetting);
    const { profileInfo } = useSelector(state => state.userPrf);
    const { deptInfo, prjdetailInfo, success5, loading5,memberInfo, memberList, prjManagerInfo,loading1,success15,deletePrjMem } = useSelector(state => state.project);
    const tenantID = profileInfo?.data?.appUser?.tenantID;
    const yearID = profileInfo?.data?.year[0]?.yearID;
    const getDateTime = profileInfo?.data?.location[0]?.gmtDate;
    const locationID = profileInfo?.data?.location[0]?.locationID;
    const isManager = profileInfo?.data?.role?.isManager;
    const managerName = profileInfo?.data?.appUser?.userName;
    const mngID = profileInfo?.data?.employeeDetail[0]?.empID;
    const [openDrawer, setOpenDrawer] = useState(false);
    const deptDetails = deptInfo?.data || [];
    const [resourceOptions, setResourceOptions] = useState([]);
    const rowData = props.data.rowData;
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const successmsg = showSuccessMsg ? success5 : null;
    const {  prjInfo,loading2, success2 } = useSelector(state => state.project);
    const memberListData = memberList?.data || [];
    const [showSuccessMsg1, setShowSuccessMsg1] = useState(false);
    const successmsg1 = showSuccessMsg1 ? success2 : null;
    const [memberID, setMemberID] = useState(0);
    const dateformat = profileInfo?.data?.settings ? profileInfo?.data?.settings[0]?.dateFormat : "DD-MM-YYYY";
    //date conversion
    let dateComponents = dateformat.split('-');
    dateComponents = dateComponents.map(component => component.toUpperCase());
    let formattedDate = dateComponents.join('-');
    const avatarColors = ["#1C3F6E", "#FFA034", "#80C271", "#2E67A0"];
    const [isMemberActive, setIsMemberActive] = useState("Active");
    const prjStartDate = dayjs(props.data?.rowData?.estStartDate) || null;
    const prjEndDate = dayjs(props.data?.rowData?.estEndDate) || null;
    const [selectedDate, setSelectedDate] = useState(null);
    const productID = profileInfo?.data?.tenantDetail?.kProductID;
    const appUserID = profileInfo?.data?.appUser?.appuserID;
    const formValue = prjdetailInfo?.data !== null ? prjdetailInfo?.data[0] : null; 
    const datas = props.data.rowData;
    const projecNo = formValue?.projectNo || "";  
    const [specificValue,setSpecificValue] = useState(); 
    const [selectedRoleOption, setSelectedRoleOption] = useState("");
    const [activeTabKey, setActiveTabKey] = useState('1');
    const [showSuccessmsg2, setShowsuccessmsg2] = useState(false);
    const successmsg2 = showSuccessmsg2 ? success15 : null;
    const [apiUrl, setApiUrl] = useState("")
    const [memberDrawer, setMemberDrawer]  = useState(false);
    const [selectedTab, setSelectedTab] = useState('1');
    const [isEditEnabled, setIsEditEnabled] = useState(false);
    const prjTypeOptions = typeList?.data?.map((item) => {
        return {
            label: item.initiativeType,
            value: item.initiativeTypeID
        }
    });
    const prjManagerList = projMngList?.data?.map((item) =>{
        return{
            label:item.fullName,
            value:item.empID, 
        }
    })
    const handleTabOnChange = (key) => {
        setSelectedTab(key);
    };
    const hanldeCloseDrawer = () => {
        setMemberDrawer(false);
    }
    const handleRoleOptionChange = (e) => {
        setSelectedRoleOption(e.target.value);
      };
    const handleTabChange = (key) => {
      setActiveTabKey(key);
    };
    function getProjectTypeList() {
        if (tenantID) {
            let ids = `${tenantID}/${locationID}/0`;
            dispatch(getProjectType(ids));
        }
    }
    function getProjectmanagerList() {
        let inputJson ={
            "ProductID": productID,
            "TenantID": tenantID,
            "IsManager": true
        }
        dispatch(getProjectManagerList(inputJson))
    }
    useEffect(() => {
        getProjectTypeList();
        getProjectmanagerList();
    }, [dispatch, tenantID]);

    useEffect(() =>{
        if(successmsg2){
            if(deletePrjMem?.data?.msg == "Deleted Successfully"){
                message.success("Team Member Deleted Successfully");
                setShowsuccessmsg2(false);
                getMemberList();
            }
            else{
                message.error(deletePrjMem?.data?.msg)
                setShowsuccessmsg2(false);
            }
        }
    },[successmsg2])
    const priorityOptions = [
        {
            label: "High",
            value: "High"
        },
        {
            label: "Medium",
            value: "Medium"
        },
        {
            label: "Low",
            value: "Low"
        }
    ];

    const billableTypeOptions = [
        {
            label: "Fixed budget",
            value: "Fixed budget",
        },
        {
            label: "Time & Material",
            value: "Time & Material"
        },
        {
            label: "Non-billable",
            value: "Non-billable"
        }
    ];

    const completionOptions = [
        {
            label:"Milestone based",
            value:"MileStone Based"
        },
        {
            label:"Project duration based",
            value:"Project duration based"
        }
    ]
    const deptOptions = deptInfo?.data?.map((item) => {
        return {
            label: item.department,
            value: item.deptID
        }
    });
    const managerOptions = prjManagerInfo?.data?.map((item) => {
        return {
            label: item.managerName,
            value: item.managerID
        }
    });
    const activeMemOptions = memberList?.data?.map((item) => {
        if (item.assignedStatus == "Active") {
            return {
                label: item.fullName,
                value: item.empID
            }
        } 
    }).filter(Boolean);
    const memberStatusOptions = [
        {
            label: "Active",
            value: "Active"
        },
        {
            label: "InActive",
            value: "InActive"
        }
    ]
    const disabledDate = (current) => {
        // Disable dates after today
        return current && current < moment().startOf('day');
    };
    const disableEstEndDate1=(current)=>{
        return current && (current < specificValue)
    }
    const handleDateChange1=(value)=>{
        setSpecificValue(value);
    }

    const fetchApiUrl = async () => {
        try {
          const response = await fetch('/api/url');
          if (response.ok) {
            const data = await response.json();
            setApiUrl(data.apiUrl)
          } else {
            // Handle errors here if needed
          }
        } catch (error) {
          // Handle network or other errors
        }
      };
      useEffect(()=>{
        fetchApiUrl();
      }, [dispatch])
    
    useEffect(() => {
        if (tenantID) {
            let ids = `${tenantID}/${locationID}`;
            dispatch(getDepartmentDetails(ids));
        }
    }, [tenantID]);

    const getMemberList = () => {

        let inputJson = {
            "TenantID": tenantID,
            "LocationID": locationID,
            "ProjectID": props.data.projectID,
            "YearID": yearID,
            "GetDateTime": getDateTime
        }
        if (tenantID) {
            dispatch(getProjectMemberList(inputJson));
        }
    }

    useEffect(() => {
        getMemberList();
    }, [tenantID]);

    const handleShowMember = () => {
        setMemberDrawer(true)
        form.resetFields();
        setMemberID(0);
        loadData();
    }
    const handleHideMember = () => {
        setMemberDrawer(false)
        setSelectedRoleOption("")
        setMemberID(0);
    }
    const handleResourceChange = (val) => {
        let b = [];
        for (let i = 0; i < deptDetails.length; i++) {
            if (val == deptDetails[i].deptID) {
                for (let j = 0; j < deptDetails[i].resourceList.length; j++) {
                    b.push(
                        {
                            label: deptDetails[i].resourceList[j].firstName,
                            value: deptDetails[i].resourceList[j].empID
                        }
                    );
                }
            }
        }
        setResourceOptions(b);
    }

    function getManagerList() {
        let ids = `${tenantID}/${locationID}/${props.data.projectID}`;
        dispatch(getProjectManager(ids));
    }
    useEffect(() => {
        getManagerList();
    }, [rowData]);

    function getProjectRoleList() {
        let ids = `${tenantID}/${locationID}/0`;
        dispatch(getProjectRole(ids));
    }
    useEffect(() => {
        getProjectRoleList();
    }, [tenantID]);

    const roleOptions = roleList?.data?.map((item) => {
        if (item.roleStatus == "Active") {
            return {
                label: item.projectRole,
                value: item.projectRoleID
            }
        }
    });

    useEffect(() => {
        if (props.data.tenantID &&  !props.data.addProject) {
            let ids = `${props.data.tenantID}/${props.data.locationID}/${props.data.projectID}`;
            dispatch(getProjDetail(ids));
        }
    }, [dispatch, props.data.tenantID]);
    const submitMember = (values) => {
        let inputJson = {
            "ProjTeamMemID": memberID,
            "ProjectID": props.data.projectID,
            "EmpID": values.resource,
            "DeptID": values.department,
            "RoleID": values.role,
            "RoleRateMode":selectedRoleOption,
            "IsProjectManager": false,
            "RoleRate":values.roleValue, 
            "AssignedStatus": values.memberStatus || "Active",
            "AssignStart": format(new Date(values.startDate), "yyyy-MM-dd"),
            "AssignEnd": format(new Date(values.endDate), "yyyy-MM-dd"),
            "TenantID": props.data.tenantID,
            "LocationID": props.data.locationID,
            "CreatedBy": props.data.appUserID
        }
        dispatch(saveProjectMember(inputJson));
        setShowSuccessMsg(true);
        setSelectedRoleOption("")
    }

    useEffect(() => {
        if (successmsg) {
            if(memberInfo?.data?.msg === "Already Exists"){
                message.error("Team Member Already Exists")
                setMemberDrawer(false)
            }
            else if(memberInfo?.data?.msg === "Saved Successfully"){
                message.success("Team Member Created Succesfully")
                setMemberDrawer(false)

            }
            else if(memberInfo?.message === "Saved Successfully"){
                message.success("Team Member Updated Succesfully")
                setMemberDrawer(false)

            }
            getMemberList();
            getManagerList();
            form.resetFields();
        }
    }, [successmsg]);
    useEffect(() => {
        if (successmsg1) {
            if(prjInfo?.data?.msg === "Saved Successfully"){
                message.success("Project Created Successfully")
                handleBack()
            }
            else if(prjInfo?.message === "Saved Successfully"){
                message.success("Project Updated Successfully")
            }
            else if(prjInfo?.data?.msg === "Already Exists"){
                message.error("Project Name Already Exists")
            }
            setOpenDrawer(false);
            setShowSuccessMsg1(false);
        }
    }, [successmsg1])

    const addCallbackFunc = (item, item1) => {
        setOpenDrawer(item);
        setShowSuccessMsg1(item1);
    }
    const handleOpenDrawer = () => {
        setOpenDrawer(true);
    }
    const deletePrjTeamMember = (value)=>{
        let ids = `${props.data.tenantID}/${value.projTeamMemID}`;
        dispatch(deleteProjectMember(ids));
        setShowsuccessmsg2(true)
    }

    const updateMember = (val) => {
        setMemberDrawer(true)
        let b = [];
        setMemberID(val.empID);
        for (let i = 0; i < deptDetails.length; i++) {
            if (val?.deptID == deptDetails[i].deptID) {
                for (let j = 0; j < deptDetails[i].resourceList.length; j++) {
                    b.push(
                        {
                            label: deptDetails[i].resourceList[j].firstName,
                            value: deptDetails[i].resourceList[j].empID
                        }
                    );
                }
            }
        }
        setResourceOptions(b);
        form.setFieldsValue({
            department: val.deptID,
            resource: val.empID,
            role: val.funcRoleID,
            roleRate : val.roleRateMode,
            roleValue : val.roleRate,
            isProjectManager: val.isProjectManager,
            memberStatus: val.assignedStatus,
            startDate: moment(val.assignStart) || null,
            endDate: moment(val.assignEnd) || null
        })
        setSelectedRoleOption(val.roleRateMode)

    }
    const loadData = () => {
        form.setFieldsValue({
            memberStatus: "Active"
        })
    }
    useEffect(() => {
        loadData();
    }, []);

    const handleMemStatusChange = (e) => {
        getMemberList();
        setIsMemberActive(e.target.value);
    }
    const handleDateChange = (value) => {
        setSelectedDate(value);
    }
    const disableEstStartDate = (current) => {
        if (prjEndDate !== null) {
            return current && (current < prjStartDate) || (current > prjEndDate);
        } else {
            return current && (current < prjStartDate);
        }
    }
    const disableEstEndDate = (current) => {
        if (prjEndDate !== null) {
            return current && (current < selectedDate) || (current > prjEndDate);
        } else {
            return current && (current < selectedDate);
        }
    }

    const handleBack=()=>{
        props.data.callbackFunc(false,false);

    }
    const onSubmitForm = () => {
        formRefs.current
        .validateFields()
        .then((values) => {
          const inputJson = {
            ProjectID: props.data.projectID,
            ProjectNo: projecNo,
            ProjectName: form1.getFieldValue('projectName'),
            ProjShortName: form1.getFieldValue('projectShortName'),
            InitiativeTypeID: form1.getFieldValue('projectType'),
            IsBillable: true,
            BillableName: form1.getFieldValue('billableType'),
            EstStartDate: format(new Date(form1.getFieldValue('estStartDate')), "yyyy-MM-dd"),
            EstEndDate: format(new Date(form1.getFieldValue('estEndDate')), "yyyy-MM-dd"),
            YearID: yearID,
            ManagerID: form1.getFieldValue('manager').toString(),
            Priority: form1.getFieldValue('priority'),
            Description: form1.getFieldValue('description'),
            ProjStatus: "Active",
            CompletionMode: form1.getFieldValue('projIndBy'),
            Sponsor: form1.getFieldValue('sponsorName'),
            ExecutiveSponsor: "",
            TenantID: tenantID,
            LocationID: locationID,
            CreatedBy: appUserID,
          };
    
          dispatch(saveProject(inputJson));
          setShowSuccessMsg1(true);
        })
        .catch((errorInfo) => {
          console.error('Form validation failed:', errorInfo);
        });
      };
      
    const loadData1 = () => {
        const dayjs = require('dayjs');
        {
            !props.data.addProject &&
            form1.setFieldsValue({
                projectName: rowData?.projectName || "",
                projectShortName: rowData?.projShortName || "",
                projectType: rowData?.initiativeTypeID || "",
                priority: rowData?.priority || "",
                billableType: rowData?.billableName|| "",
                sponsorName: rowData?.sponsor || "",
                description:rowData?.description,
                projIndBy: rowData?.completionMode || "",
                estStartDate: datas ? dayjs(datas?.estStartDate) : null,
                estEndDate: datas ? dayjs(datas?.estEndDate) : null,
                manager: rowData?.managerList[0]?.managerID|| "",
            });
            setSpecificValue(moment(datas?.estStartDate));

        }
    }

    const hasInactiveMembers = memberListData?.some(item => item.assignedStatus === "InActive" && isMemberActive === "InActive");
    const hasActiveMembers = memberListData?.some(item => item.assignedStatus === "Active" && isMemberActive === "Active");

    const items1 = [
        {
            key: "1",
            label: "Project Plan",
            children: <ProjectPlan data={{ tenantID: tenantID, locationID: locationID,initiativeTypeID:rowData.initiativeTypeID, yearID: yearID, rowData: props.data.rowData, projectID: props.data.projectID, projectNo:props.data.projectNo, appUserID: props.data.appUserID, memberOptions: activeMemOptions, prjEndDate: rowData?.estEndDate, apiUrl: apiUrl, addProject: props.data.addProject }} />,
            disabled: props.data.addProject,
        },
        {
            key: "2",
            label: "Gantt Chart View",
            children: <GanttChart data={{tenantID: tenantID, locationID: locationID,initiativeTypeID:rowData.initiativeTypeID, projectID: props.data.projectID, tabKey: selectedTab, prjDetails: prjdetailInfo?.data}} />,
            disabled: props.data.addProject,
        },
        {
            key: "3",
            label: "Team Member",
            children: (
                <div>
                    <div className='col p-2 bg-white  PrjMenCont'>
                    <div className='row my-auto py-2 px-2'>
                        <h6 className='col-auto my-auto '>Project Team Members</h6>
                        <div className='col-auto ms-auto d-flex'>
                            <Radio.Group defaultValue={isMemberActive} buttonStyle="solid" onChange={handleMemStatusChange}>
                                <Radio.Button value="Active">Active</Radio.Button>
                                <Radio.Button value="InActive">InActive</Radio.Button>
                            </Radio.Group>
                            {
                                !props.data.addProject &&
                                <Tooltip title="Add/Update Team Member" className='mt-0'>
                                    <PlusOutlined className="my-auto ms-2 pointer" onClick={handleShowMember} />
                                </Tooltip>
                            }
                        </div>
                    </div>
                    <Divider className='my-2' />
                    {
                        !props.data.addProject && (
                        <Spin spinning={loading1}>
                            {isMemberActive == "Active" ?
                                <div className='d-flex row pb-3'>
                                    {
                                        hasActiveMembers ? (
                                            memberListData?.map((item, i) => {
                                                if (item.assignedStatus == "Active" && isMemberActive == "Active") {
                                                    return (
                                                        <div className= 'addMemberCont ms-3 me-4 card bg-light col-md-4  border-0 py-3 px-2 mt-3' key={item.empID}>
                                                            {item ?
                                                                <div className='row m-0'>
                                                                    <div className='col-auto'>
                                                                        <Avatar className='text-capitalize' style={{ backgroundColor: `${avatarColors[i % avatarColors.length]}` }}>{item.fullName?.substring(0, 1)}</Avatar>
                                                                    </div>
                                                                    <div className='col'>{item.fullName}</div>
                                                                    <div className='col text-primary fw-bold'>{item.roleName}</div>
                                                                    <div className='col-md-3'>Assigned On
                                                                        <br />
                                                                        {format(new Date(item.assignStart),dateformat)}</div>
                                                                    <div className='col-auto pointer'>
                                                                        <span className='pe-2'>
                                                                            <Tooltip title="Edit Team Member" className='mt-0'>
                                                                                <EditFilled className='pointer' onClick={() =>{updateMember(item);setMemberID(item?.projTeamMemID);} } />
                                                                            </Tooltip>
                                                                        </span>
                                                                        {/* <span className='pe-2'>
                                                                            <Popconfirm
                                                                                description="Are you sure to delete this Team Member?"
                                                                                onConfirm={()=>deletePrjTeamMember(item)}
                                                                                okText="Yes"
                                                                                cancelText="No"
                                                                                >
                                                                                <span><Tooltip title="Delete Team Member" className='mt-0'><DeleteOutlined className='me-1 text-danger' /></Tooltip> </span>
                                                                            </Popconfirm>
                                                                        </span> */}
                                                                        
                                                                    </div>
                                                                </div> :
                                                                <Empty image={<TeamOutlined />} description="No Active Team Members Assigned" />}
                                                        </div>
                                                    )
        
                                                }
                                            }))
                                            :
                                            ( <div className='p-5' >
                                                <Empty image={<TeamOutlined />} description="No Active Team Members Assigned" />
                                             </div>)
                                    }
                                </div>
                                : <div className='d-flex row pb-3'>
                                     {hasInactiveMembers ? (
                                        memberListData?.map((item, i) => {
                                            if (item.assignedStatus == "InActive" && isMemberActive == "InActive") {
                                                return (
                                                    <div className='addMemberCont ms-3 me-4 card bg-light border-0 py-3 px-2 mt-3' key={item.empID}>
                                                        {item ?
                                                            <div className='row m-0'>
                                                                <div className='col-auto'>
                                                                    <Avatar className='text-capitalize' style={{ backgroundColor: `${avatarColors[i % avatarColors.length]}` }}>{item.fullName?.substring(0, 1)}</Avatar>
                                                                </div>
                                                                <div className='col'>{item.fullName}</div>
                                                                <div className='col text-primary fw-bold'>{item.roleName}</div>
                                                                <div className='col-md-3'>Assigned On
                                                                    <br />
                                                                    {format(new Date(item.assignStart), dateformat)}</div>
                                                                <div className='col-auto pointer'>
                                                                    <span className='pe-2'>
                                                                        <Tooltip title="Edit Team Member" className='mt-0'>
                                                                            <EditFilled className='pointer' onClick={() =>{updateMember(item);setMemberID(item?.projTeamMemID);} } />
                                                                        </Tooltip>
                                                                    </span>
                                                                    {/* <span className='pe-2'>
                                                                        <Popconfirm
                                                                            description="Are you sure to delete this Team Member?"
                                                                            onConfirm={()=>deletePrjTeamMember(item)}
                                                                            okText="Yes"
                                                                            cancelText="No"
                                                                            >
                                                                            <span><Tooltip title="Delete Team Member" className='mt-0'><DeleteOutlined className='me-1 text-danger' /></Tooltip></span>
                                                                        </Popconfirm>
                                                                    </span> */}
                                                                </div>
                                                            </div> :
                                                            <div >
                                                                <Empty image={<TeamOutlined />} description="No Inactive Team Members Assigned" />
                                                            </div>}
                                                    </div>
                                                )

                                            }
                                        })
                                     ):
                                     ( <div className='p-5' >
                                        <Empty image={<TeamOutlined />} description="No Inactive Team Members Assigned" />
                                    </div>)}
                                </div>
                            }
                                </Spin>
                        )
                    }
                    
                    {
                        props.data.addProject == true &&
                        <div className='mt-5'>
                            <Empty image={<TeamOutlined />} description="Create project to Assign Team Members" />
                        </div>
                    }

                </div> 
                </div> ),
            disabled: props.data.addProject,
        },
        // {
        //     key: "3",
        //     label: "Effort Summary",
        //     children: <EffortSummary />,
        //     disabled: props.data.addProject,
        // },
        // {
        //     key:'4',
        //     label:"Project Financials",
        //     children:<FinanceByRole data={{ tenantID: tenantID, locationID: locationID, yearID: yearID,projectID: props.data.projectID,}}/>
        // }

    ];
    const handleEditable =()=>{
        setIsEditEnabled(!isEditEnabled)
    }
    useEffect(()=>{
        if(props.data.addProject){
            setIsEditEnabled(true)
        }
        else if(!props.data.addProject){
            setIsEditEnabled(false)
        }
    },[props.data.addProject])
   
    useEffect(() => {
        loadData1();
    }, []);
    return (    
        <>  <div className='row m-0 project-detail-header'>
            {props.data.addProject ?<h5 className='my-auto col-auto'> Add Project</h5> :
            <div className='my-auto col-auto d-flex'>
                <h5 className='my-auto col-auto pe-2'> Update Project</h5>
                <Tooltip title={isEditEnabled ? "Disable Edit " : "Enable Edit"}>
                    <img
                        src={isEditEnabled ? nonEditIcon : editIcon}
                        alt={isEditEnabled ? 'Check Icon' : 'Edit Icon'}
                        className='switchEditIcon' 
                        onClick={handleEditable}
                    />
                    {/* <div className='edit-container'>
                        <EditFilled className={isEditEnabled ? 'strikethrough' : ''} onClick={handleEditable} />
                    </div> */}
                </Tooltip>
            </div>
            }
            <div className='col-auto ms-auto d-flex text-primary pointer p-2'>
                <Button type="default" className="ms-auto mb-2" onClick={handleBack}>Back</Button>
            </div>
        </div>
            <div className='row m-0 h-100 mt-2'>
                <div className='col-md-12 bg-white me-2 p-3 h-100  prj-detail-cont'>
                    <div className='bg-blue p-3'>
                        <Form
                            ref={formRefs}
                            form={form1}
                            layout="vertical">
                            <div className='row'>
                                {
                                    !props.data.addProject  &&
                                    <div className='form-group col-md-2'>
                                        <Form.Item label="Project #" name="projectId" className='col'
                                        initialValue={rowData?.projectNo}
                                        >
                                            <Input  disabled/>
                                        </Form.Item>
                                    </div>
                                }
                                <div className={`${!props.data.addProject ? "col-md-2" : "col-md-4"} form-group`}>
                                    <Form.Item label="Project Name/Title" name="projectName" className='col right-col'
                                        rules={[{ required: true, message: "This field is required" }]}>
                                        <Input disabled={!isEditEnabled} />
                                    </Form.Item>
                                </div>
                                <div className='form-group col-md-2'>
                                    <Form.Item label="Project Short Name" name="projectShortName" className='col'
                                        rules={[{ required: true, message: "This field is required" }]}>
                                        <Input disabled={!isEditEnabled} />
                                    </Form.Item>
                                </div>
                                <div className='form-group col-md-2'>
                                    <Form.Item label="Project Type" name="projectType" className='col right-col'
                                        rules={[{ required: true, message: "This field is required" }]}>
                                        <Select className='hide-proj' options={prjTypeOptions} disabled={!props.data.addProject && !isEditEnabled} />
                                    </Form.Item>
                                </div>
                                <div className='form-group col-md-2'>
                                    <Form.Item label="Priority" name="priority" className='col'
                                        rules={[{ required: true, message: "This field is required" }]}>
                                        <Select className='hide-proj' options={priorityOptions} disabled={!isEditEnabled}/>
                                    </Form.Item>
                                </div>
                                <div className='form-group col-md-2'>
                                    <Form.Item label="Billable Type" name="billableType" className='col right-col'
                                        rules={[{ required: true, message: "This field is required" }]}>
                                        <Select className='hide-proj' options={billableTypeOptions} disabled={!props.data.addProject && !isEditEnabled} />
                                    </Form.Item>
                                </div>
                                
                            </div>
                            <div className='row my-2 px-0'>
                                <div className='form-group col-md-2'>
                                    <Form.Item label="Sponsor Name" name="sponsorName" className='col'
                                        rules={[{ required: true, message: "This field is required" }]}>
                                        <Input disabled={!isEditEnabled}/>
                                    </Form.Item>
                                </div>
                                <div className="form-group col-md-4">
                                    <Form.Item label="Description" name="description" className='col right-col'>
                                        <TextArea rows={3} disabled={!isEditEnabled}/>
                                    </Form.Item>
                                </div>
                                <div className='form-group col-md-2 '>
                                    <Form.Item label="Project Manager" name="manager" className='' rules={[{ required: true, message: "This field is required" }]}
                                        initialValue={isManager? mngID :null}
                                    >
                                        <Select className='hide-proj'  options={prjManagerList} disabled={!isEditEnabled}/>
                                    </Form.Item>
                                </div>
                                <div className='form-group col'>
                                    <Form.Item  label="Progress indicator by" name="projIndBy" className='col right-col'
                                    rules={[{ required: true, message: "This field is required" }]}
                                    >
                                        <Radio.Group disabled={!isEditEnabled} className='hide-proj'>
                                            {completionOptions?.map(option => (
                                            <Radio
                                                key={option.value}
                                                value={option.value}
                                                className="circle-radio"
                                            >
                                                {option.label}
                                            </Radio>
                                            ))}
                                        </Radio.Group>
                                    </Form.Item>
                                    </div>
                            </div>
                            <div className='row m-0'>
                                <div className='form-group col-md-3  ps-0'>
                                    <Form.Item label="Start Date" name="estStartDate" className='col '
                                        rules={[{ required: true, message: "This field is required" }]}>
                                        <DatePicker format={formattedDate } className='w-100'
                                            disabledDate={(current) =>disabledDate(current)} onChange={handleDateChange1} disabled={!isEditEnabled}
                                        />
                                    </Form.Item>
                                </div>
                                <div className='form-group col-md-3'>
                                    <Form.Item label="End Date" name="estEndDate" className='col right-col'
                                    rules={[{ required: true, message: "This field is required" }]}>
                                        <DatePicker format={formattedDate} className='w-100'
                                        disabledDate={(current)=>disableEstEndDate1(current)} disabled={!isEditEnabled}
                                        />
                                    </Form.Item>
                                </div>
                                <div className=' col d-flex justify-content-end align-items-center'>
                                    {/* {activeTabKey === '1' && (  */}
                                    <Button className='btn btn-primary dlv-save-btn mb-3' loading={loading2} disabled={!isEditEnabled}  onClick={onSubmitForm}>Save</Button>
                                    {/* )} */}
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>

                <div className='bg-white'>
                     <div className='mt-2 project-tabs mb-3'>
                        <Tabs 
                            defaultActiveKey='1'
                            activeKey={activeTabKey}
                            onTabClick={handleTabChange}
                            items={items1}
                            onChange={handleTabOnChange}
                        />
                    </div>
                    
                </div>
            </div>

            <Drawer forceRender className='TemplateDrawer'  title="Add/Update Team Member" width={550} placement="right" onClose={hanldeCloseDrawer}  open={memberDrawer}>
            <Form
                            form={form}
                            onFinish={submitMember}
                            layout="vertical"
                            className='p-2'
                        >
                            <Form.Item label="Department" name="department"
                                rules={[
                                    {
                                        required: true,
                                        message: "This field is required"
                                    }
                                ]}>
                                <Select options={deptOptions} onChange={handleResourceChange} />
                            </Form.Item>
                            <Form.Item label="Resource" name="resource"
                                rules={[
                                    {
                                        required: true,
                                        message: "This field is required"
                                    }
                                ]}>
                                <Select options={resourceOptions} />
                            </Form.Item>
                            <Form.Item label="Project Role" name="role"
                                rules={[
                                    {
                                        required: true,
                                        message: "This field is required"
                                    }
                                ]}>
                                <Select options={roleOptions} />
                            </Form.Item>
                            <Form.Item label="Role Rate" name="roleRate" className='mb-0'
                                rules={[
                                    {
                                        required: true,
                                        message: "This field is required"
                                    }
                                ]}>
                                <Radio.Group onChange={handleRoleOptionChange} value={selectedRoleOption} className='pb-2'>
                                    <Radio value="Fixed hours">Fixed Hours</Radio>
                                    <Radio value="Billable hours">Billable Hours</Radio>
                                </Radio.Group>
                            </Form.Item>
                            {
                                selectedRoleOption !== "" &&
                                <Form.Item name="roleValue" className='teamRoleValue'
                                    rules={[
                                        {
                                            required: true,
                                            message: "This field is required"
                                        }
                                    ]}>
                                    <Input type='number'  />
                                </Form.Item>
                            }
                            {/* {
                                !isManager && (
                                    <Form.Item label="Is Project Manager" name="isProjectManager" valuePropName="checked">
                                        <Checkbox>Yes</Checkbox>
                                    </Form.Item>
                                )
                            } */}
                            <Form.Item label="Start Date" name="startDate" className='mt-1'
                                rules={[
                                    {
                                        required: true,
                                        message: "This field is required"
                                    }
                                ]}
                                // initialValue={selectedDate}
                                >
                                <DatePicker className='w-100' disabledDate={disableEstStartDate} format={formattedDate}
                                    onChange={handleDateChange} />
                            </Form.Item>
                            <Form.Item label="End Date" name="endDate"
                                rules={[
                                    {
                                        required: true,
                                        message: "This field is required"
                                    }
                                ]}
                                >
                                <DatePicker className='w-100' format={formattedDate}
                                    disabledDate={disableEstEndDate} />
                            </Form.Item>
                            {memberID == 0 ? "" :
                                <Form.Item label="Status" name="memberStatus">
                                    <Select options={memberStatusOptions} />
                                </Form.Item>
                            }
                            <div className='row m-0 text-end'>
                                <Button type="primary ms-auto cancel-btn"  className="dlv-cancel-btn me-1" danger onClick={handleHideMember}>Cancel</Button>
                                <Button type="primary save-btn ms-1" className='dlv-save-btn ms-1' htmlType='submit' loading={loading5}>Save</Button>
                            </div>
                        </Form>
            </Drawer>
            {openDrawer && <AddProject data={{ projectID: props.data.projectID, formVal: rowData, dateformat: dateformat, rowData: prjdetailInfo?.data, addCallbackFunc: addCallbackFunc, openDrawer: openDrawer }} />}
        </>
    )
}